const _ = require('lodash');

const AddressService = function AddressService($rootScope, restangular, trolleyService, storePickerService, settingsService) {
    this._addressRoute = restangular.one('address');
    this.restangular = restangular;
    this.$rootScope = $rootScope;
    this.suburbs = [];
    this.autoAddresses = [];
    this.savedAddresses = [];
    this.savedAddress = {};
    this.searchError = { Id: '', Text: '' };
    this.savedError = { ErrorType: '', ErrorCode: '', ErrorMessage: '', ErrorResponse: [] };
    this.query = '';
    this.pickupaddresses = [];
    this.trolleyService = trolleyService;
    this.savedAddressesCount = 0;
    this.isNonServiced = false;
    this.autoAddressSearchTerm = '';
    this.autoAddressDeliveryMethod = '';
    this.autoAddressSource = ''; // Keep tracking of current template.
    this.isAutoAddressBillingAddress = false;
    this.nonServicedAddressResult = false;
    this.billingAddress = {};
    this.storePickerService = storePickerService;
    this.useCompanyNameField = false;
    const self = this;
    settingsService.getSettingValue('Address', 'UseCompanyNameField').then(function (isEnabled) { self.useCompanyNameField = isEnabled; });
};

AddressService.prototype._searchSuccess = function (response) {
    if (response.Response !== null && response.Response.length > 0 && response.Response[0].Id !== '') {
        this.autoAddresses = response.Response;
    } else {
        this.autoAddresses = [];
    }

    return this.autoAddresses;
};

AddressService.prototype._searchFailure = function () {
    this.searchError = { Id: 'n/a', Text: `An error has occured searching for ${this.query}` };
    return false;
};

AddressService.prototype._saveSuccess = function (response) {
    this.isNonServiced = response.IsNonServiced;
    if (response.Address !== null && response.Address.AddressId === 0) {
        this.savedError.ErrorType = 'Authentication Error';
        this.savedError.ErrorCode = 'Shopper is guest';
        this.savedError.ErrorMessage = 'Addresses cannot be saved for guest users.';
        return false;
    } else if (response.Address !== null && response.Address.AddressText.length > 0) {
        this.savedAddress = response.Address;
        this.trolleyService.getTrolley();
        return true;
    }

    this.savedError.ErrorType = 'Service Stack Error';
    this.savedError.ErrorCode = 'Invalid response';
    this.savedError.ErrorMessage = 'The address has failed to save.';
    return false;
};

AddressService.prototype._saveFailure = function (response) {
    this.savedError = response;
    return false;
};

AddressService.prototype._suburbSuccess = function (response) {
    if (response.Response !== null && response.Response.length > 0) {
        this.suburbs = response.Response;
    } else {
        this.suburbs = [];
    }

    return this.suburbs;
};

AddressService.prototype._suburbFailure = function () {
    this.suburbs = [];
    return this.suburbs;
};

AddressService.prototype._selectedAddress = function () {
    this.$rootScope.$broadcast('address:setPickupAddress');
};

AddressService.prototype._setDeliveryAddress = function () {
    this.$rootScope.$broadcast('address:setDeliveryAddress');
};

AddressService.prototype._savedAddressesSuccess = function (response) {
    if (response && response.rawResponse.length > 0) {
        this.savedAddresses = response.rawResponse;
        this.savedAddressesCount = response.rawResponse.length;
    } else {
        this.savedAddresses = {};
    }

    this.billingAddress = _.find(response.rawResponse, function (address) {
        return address.IsBilling === true;
    });

    this.primaryAddress = _.find(response.rawResponse, function (address) {
        return address.IsPrimary === true;
    });

    this.savedAddress = this.primaryAddress;

    return response.rawResponse;
};

AddressService.prototype._savedAddressesFailure = function () {
    this.savedAddresses = {};
    return false;
};

AddressService.prototype.search = function (query) {
    this.query = query;
    return this._addressRoute.one('search').doPOST({
        Search: query
    }).then(this._searchSuccess.bind(this), this._searchFailure.bind(this));
};

AddressService.prototype.save = function (address) {
    return this._addressRoute.one('auto').doPOST(address)
        .then(this._saveSuccess.bind(this), this._saveFailure.bind(this));
};

AddressService.prototype.saveManual = function (address) {
    return this._addressRoute.one('manual').doPOST(address).then(this._saveSuccess.bind(this), this._saveFailure.bind(this));
};

AddressService.prototype.getSuburbs = function (query) {
    this.query = query;
    return this._addressRoute.one('suburb', query).get()
        .then(this._suburbSuccess.bind(this), this._suburbFailure.bind(this));
};

AddressService.prototype.setPickupAddress = function (address) {
    const self = this;

    return this._addressRoute.one('SetPickup').doPOST({ AddressId: address.AddressId }).then(function () {
        self.savedAddress.AddressText = address.Description;
        self._selectedAddress();
        self.$rootScope.$broadcast('address-update');
    });
};

AddressService.prototype.getPickupAddresses = function (args) {
    const self = this;
    return this._addressRoute.one('pickupaddresses').get(args).then(function (data) {
        self.pickupaddresses = data.Response;
        return self.pickupaddresses;
    });
};

AddressService.prototype.getAllAddresses = function () {
    return this._addressRoute.one('all').get().then(this._savedAddressesSuccess.bind(this), this._savedAddressesFailure.bind(this));
};

AddressService.prototype.getSavedAddresses = function () {
    return this._addressRoute.one('all').get().then(this._savedAddressesSuccess.bind(this), this._savedAddressesFailure.bind(this));
};

AddressService.prototype.saveSelectedSavedAddress = function (address) {
    this.savedAddress = address;
    this.primaryAddress = address;
    return this.setPrimaryAddress(address.AddressId);
};

AddressService.prototype.setAddress = function (address) {
    this.savedAddress = address;
};

AddressService.prototype.delete = function (address) {
    return this._addressRoute.one('delete').doPOST({ AddressId: address.AddressId });
};

AddressService.prototype.updateAutoAddress = function (savedAddressId, selectedAddress, deliveryMethod) {
    return this._addressRoute.one('updateAuto').doPOST({ SavedAddressId: savedAddressId, DeliveryMethod: deliveryMethod, SelectedAddressId: selectedAddress.Id })
        .then(this._saveSuccess.bind(this), this._saveFailure.bind(this));
};

AddressService.prototype.isNonServicedAddress = function (postcode, amasAddressId) {
    return this._addressRoute.one('IsNonService').get({ Postcode: postcode, AmasAddressId: amasAddressId });
};


AddressService.prototype.updateManualAddress = function (savedAddressId, newAddress, deliveryMethod) {
    return this._addressRoute.one('updateManual').doPOST({
        SavedAddressId: savedAddressId,
        DeliveryMethod: deliveryMethod,
        Street1: newAddress.street1,
        Street2: newAddress.street2,
        SuburbId: newAddress.suburbId,
        Postcode: newAddress.postcode,
        ContactNumber: newAddress.ContactNumber
    }).then(this._saveSuccess.bind(this), this._saveFailure.bind(this));
};

AddressService.prototype.switchModes = function (mode) {
    this.addressMode = mode;
    return this.addressMode;
};

AddressService.prototype.setPartnerDeliveryAddress = function (address) {
    const self = this;
    return this._addressRoute.one('SetDelivery').one('PartnerBranch', address.PartnerBranchId).post().then(function () {
        self.savedAddress = address;
        self.trolleyService.getTrolley();
    });
};

AddressService.prototype.addressOnType = _.throttle(function (searchTerm) {
    const self = this;
    const keyword = (searchTerm && searchTerm.length > 0) ? searchTerm : self.autoAddressSearchTerm;
    return self.search(keyword);
}, 500);

AddressService.prototype._clearAutoAddresses = function () {
    this.searchError = { Id: '', Text: '' };
    this.autoAddresses = [];
};

AddressService.prototype.addressOnSelect = function (addr) {
    const self = this;
    let deliveryMethod = '';
    if (addr != null && addr.Id !== 'n/a') {
        self._clearAutoAddresses();
        self.autoAddressSearchTerm = '';
        self.autoAddressSource = addr.source;
        deliveryMethod = self.autoAddressDeliveryMethod && self.autoAddressDeliveryMethod.name ? self.autoAddressDeliveryMethod.name : '';
        self.save(addr, deliveryMethod, self.isAutoAddressBillingAddress)
            .then(function (success) {
                if (success) {
                    self._broadcast('address-update');
                    self.autoAddressSearchTerm = '';
                    self._broadcast('auto-address-saved');
                } else if (self.savedError.ErrorType === 'Authentication Error') {
                    self._broadcast('authentication:invalid');
                } else {
                    self._broadcast('address-save-error');
                }
            });
    }
};

AddressService.prototype._addressOnSelectWithoutSaving = function (addr) {
    const self = this;
    if (addr != null && addr.Id !== 'n/a') {
        self._clearAutoAddresses();
        self.autoAddressSearchTerm = addr.Text;
        self._broadcast('auto-address-selected');
    }
};


AddressService.prototype.addressSearchTermClear = function () {
    this.autoAddressSearchTerm = '';
};

// To increase testability of the service.
AddressService.prototype._broadcast = function (name) {
    this.$rootScope.$broadcast(name);
};

AddressService.prototype.setBillingAddress = function (addressId) {
    return this._addressRoute.one('SetBillingAddress').doPOST({ AddressId: addressId });
};

AddressService.prototype.setPrimaryAddress = function (AddressId) {
    return this._addressRoute.one('SetPrimaryAddress').doPOST({ AddressId });
};

module.exports = AddressService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/address/address-service.js
 **/